import React from "react";
import { Link } from "react-router-dom";
import "./Main.css";

const Main = () => {
    return (
        <div className='main__bg'>
            <div className='main__frame'>
                <h2 className='main__title'>Planero Web "Consulta ciudadana"</h2>
                <p className='main__subtitle'>TEXTO REFUNDIDO DEL PLANEAMIENTO VIGENTE DE RONDA 2022
                </p>
                <Link to="/planero/A_CALIFICACION Y USOS_actualizado_V1">

                    <button className='main__bt'>Accede</button>
                </Link>
                <p className='main__geoinnova'>Más información <a href="https://urbanismoronda.es/">Geoportal de planeamiento urbanístico de Ronda</a></p>
                {/* popup  */}
                <div id="popup" className="ol-popup no-visible">
                    <a href="#" id="popup-closer" className="ol-popup-closer">&times;</a>
                    <div id="popup-content"></div>
                </div>
            </div>

        </div>
    )
}
export default Main;